window._ = require("lodash");

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

try {
    // window.Popper = require("popper.js").default;
    window.$ = window.jQuery = require("jquery");
    // require("bootstrap");
} catch (e) {}

window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.axios.interceptors.response.use(
    function (response) {
        // Event.fire("reset-timer");
        // Do something with response data
        return response;
    },
    function (error) {
        if (error.response) {
            if (error.response.status == 406 || error.response.status == 418) {
                Eventing.fire("show2FA");
                // window.location.href = "/#access";
            }
            if (error.response.status == 401) {
                //  Event.fire("conflict");
            }
            if (error.response.status == 500) {
                //  Event.fire("real-error");
                //  Event.fire("stopLoading");
                Eventing.fire("notify", {
                    title: "Server error",
                    message: "Daar ging wat mis",
                    type: "error",
                });
            }
            if (error.response.status == 403 || error.response.status == 401) {
                //  Event.fire("real-error");
                //  Event.fire("stopLoading");
                Eventing.fire("notify", {
                    title: error.response.status + ": Forbidden",
                    message:
                        "Dit account heeft niet voldoende rechten om deze actie uit te voeren",
                    type: "error",
                });
                Eventing.fire("backHome");
            }

            if (error.response.status == 410) {
                Eventing.fire("notify", {
                    title: "Forbidden",
                    message:
                        "Dit account heeft niet voldoende rechten om deze actie uit te voeren",
                    type: "error",
                });
                setTimeout(() => {
                    window.location.href = "/logoff";
                }, 10000);
            }

            if (error.response.status == 502) {
                //  Event.fire("real-error");
                //  Event.fire("stopLoading");
                Eventing.fire("notify", {
                    title: "Time-out",
                    message:
                        "De server is druk. Probeer het over een paar minuten nogmaals. Het beste kunt u de pagina nu niet verversen.",
                    type: "alert",
                });
            }
        }
        // Do something with response error
        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.Pusher = require("pusher-js");

window.Echo = new Echo({
    broadcaster: "pusher",
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true,
});
